module.exports = __webpack_public_path__ + "img/13_23.f420bc52.png";